<template>
  <TarjetaDatos titulo="Tomador">
    <Campo2L :valor="poliza.nombreTomador" />
    <CampoPhone :valor="poliza.telefonoTomador" />
    <CampoEmail :valor="poliza.emailTomador" />
    <Campo2L :valor="poliza.direccionTomador" etiqueta="Dirección" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
